import React from 'react';
import {
  openPopupWindow,
} from '../../../../../../emitters/popup';
import ButtonDecline from '../../../../../dumb/Button/Decline';
import ButtonRed from '../../../../../dumb/Button/Red';
import Popup from '../../../../../dumb/Popup/B';
import FieldC from '../../../../../dumb/Field/C';
import Tooltip from '../../../../../dumb/Tooltip/B';
import WrapperWithLoading from '../../../../../dumb/WrapperWithLoading/B';
import {apiV2CryptoAccountDelete} from "../../../../../../api/merchant/cryptoAccounts";


module.exports = (data, callback) => {
  data = data || {};
  const {
    id,
  } = data;

  openPopupWindow((setPopupState, popup) => {
    const {
      close,
    } = popup;
    return (stateOfPopup) => {
      return (
        <Popup
          caption="Are you sure you want to delete this bank account?">
          <WrapperWithLoading loading={stateOfPopup.loading}>
            <div className="cfx mt30 mh-10 (lt|ph10|w1/3|w1/4@d2|w1/2@m|w@m2)>1">
              <FieldC
                label="Bank name"
                value={(
                  <Tooltip>
                    {data.name || '-'}
                  </Tooltip>
                )}
              />
              <FieldC
                label="Iban"
                value={(
                  <Tooltip>
                    {data.iban}
                  </Tooltip>
                )}
              />
              <FieldC
                label="Currency"
                value={(
                  <Tooltip>
                    {data.fiat_code}
                  </Tooltip>
                )}
              />
              <FieldC
                label="Swift code"
                value={(
                  <Tooltip>
                    {data.swift_code}
                  </Tooltip>
                )}
              />
            </div>

            <div className="cfx mh-10 (lt|ph10|pt20)>1">
              <div>
                <ButtonRed
                  onClick={() => {
                    setPopupState({
                      loading: true,
                    });
                    apiV2CryptoAccountDelete({
                      id,
                    }).finally((error) => {
                      setPopupState({
                        loading: false,
                      });
                      if (error) {
                        return;
                      }
                      callback();
                      close();
                    });
                  }}
                >Delete</ButtonRed>
              </div>
              <div>
                <ButtonDecline
                  onClick={close}
                >Cancel</ButtonDecline>
              </div>
            </div>
          </WrapperWithLoading>
        </Popup>
      );
    };
  });
};
